RivalIQ.apps.Alerts.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.AlertFilter = Marionette.ItemView.mixin({
        template: '#alertsAlertFilterTemplate',
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },
        events: {
            'click a': 'onClickFilter'
        },
        dashboardModelEvents: {
            'change': 'render'
        },
        className: 'dropdown',
        onClickFilter: function (e) {
            const me = this;
            e.preventDefault();

            const eventClass = $(e.currentTarget).data('event-class');
            me.setProps({
                eventClass: eventClass
            });
        },
        templateHelpers: function () {
            const me = this;

            const alertFilters = App.enums.getAlertFilters();

            const type = alertFilters[me.getProp('eventClass')] || alertFilters.alertsAll;

            return {
                type: type,
                types: _.values(alertFilters).sort(function (a, b) {
                    if (a.name === alertFilters.alertsAll.name) {
                        return -1;
                    }

                    if (b.name === alertFilters.alertsAll.name) {
                        return 1;
                    }

                    return a.name.localeCompare(b.name);
                })
            };
        }

    });
});
